import React, { Suspense } from "react";
import TopNavBar from "./components/Scaffold/TopNavBar";
import SnackbarAlert from "./components/SnackbarAlert";
import Footer from "./components/Scaffold/Footer";
import LoadingIcon from "./components/UI/LoadingIcon";
import MultiDrinkOptions from "./components/MultiDrinkOptions";
import "./App.css";

const ContainerContent = React.lazy(() => import("./components/ContainerContent"));

function App() {
  return (
    <div className='App'>
      <TopNavBar />
      <Suspense fallback={<LoadingIcon />}>
        <ContainerContent />
      </Suspense>
      <SnackbarAlert />
      <Footer />
    </div>
  );
}

export default App;
